<div class="card">
    <app-header titulo="Baixa de insumo" descricao="Dados das baixas de insumos"></app-header>

    <p-table [value]="consumiveis" [(selection)]="consumiveisSelecionados" dataKey="idConsum" #dt [loading]="loading" [globalFilterFields]="['moduloOrigem','instancia','noBoletim','noSequencia','cdMaterialPims','dtMovimento','noOs','cdCcustoPims','fgTpMovim','cdEmpresaErp','cdFilialErp','cdMaterialErp','qtConsumo','cdUnidadeErp','cdCcustoErp','cdDepositoErp','noDocErp','fgRevertido','fgStatusInteg','dtIntegPims','dtIntegErp','deMensagemInteg']" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100, 500, 1000]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="{{consumiveisSelecionados.length}} Registros selecionados | Mostrando de {first} até {last} de {totalRecords} registros" [scrollable]="true" scrollHeight="40.5rem" >
        <ng-template pTemplate="caption">
            <div class="flex">
                <p-multiSelect
                 appendTo="body"
                 [options]="instancias"
                 [filter]="true"
                 [style]="{'width':'200px'}"
                 optionValue="id"
                 optionLabel="nome"
                 [(ngModel)]="instanciaSelecionada"
                 dataKey="id" inputId="id"
                 placeholder="Instância"
                 emptyMessage="Nenhuma instância"
                 (onChange)="getConsumiveis()">
                
                </p-multiSelect>
                <p-calendar
                class="ml-3"
                  [(ngModel)]="rangeDates"
                  selectionMode="range"
                  dateFormat="dd/mm/yy"
                  [readonlyInput]="true" 
                  (onClose)="getConsumiveis()"/>
                
                  <button pButton pRipple icon="pi pi-file-excel" class="ml-3" (click)="exportar()" label="Exportar"></button>

                
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
                </span>
                <button pButton pRipple icon="pi pi-refresh" class="ml-3" (click)="getConsumiveis()"></button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
                <th>Instância</th>
                <th>Boletim</th>
                <th>Sequência</th>
                <th>Material PIMS</th>
                <th>Data Movimento</th>
                <th>OS</th>
                <th>Centro Custo (PIMS)</th>
                <th>Movimento</th>
                <th>Empresa (ERP)</th>
                <th>Filial (ERP)</th>
                <th>Material (ERP)</th>
                <th>Quantidade Consumo</th>
                <th>Unidade (ERP)</th>
                <th>Centro Custo (ERP)</th>
                <th>Depósito (ERP)</th>
                <th>No DOC (ERP)</th>
                <th>Revertido</th>
                <th pSortableColumn="fgStatusInteg">Status <p-sortIcon field="fgStatusInteg" /></th>
                <th>Data Envio PIMS</th>
                <th>Data Integrado</th>
                <th pSortableColumn="deMensagemInteg">Mensagem <p-sortIcon field="deMensagemInteg" /></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-consumivel>
            <tr>
                <td><p-tableCheckbox [value]="consumivel" /></td>
                <td>{{ consumivel.instancia }}</td>
                <td>{{ consumivel.noBoletim }}</td>
                <td>{{ consumivel.noSequencia }}</td>
                <td>{{ consumivel.cdMaterialPims }}</td>
                <td>{{ consumivel.dtMovimento | date: 'dd/MM/yyyy' }}</td>
                <td>{{ consumivel.noOs }}</td>
                <td>{{ consumivel.cdCcustoPims }}</td>
                <td>{{ consumivel.fgTpMovim }}</td>
                <td>{{ consumivel.cdEmpresaErp }}</td>
                <td>{{ consumivel.cdFilialErp }}</td>
                <td>{{ consumivel.cdMaterialErp }}</td>
                <td>{{ consumivel.qtConsumo.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  || 0 }}</td>
                <td>{{ consumivel.cdUnidadeErp }}</td>
                <td>{{ consumivel.cdCcustoErp }}</td>
                <td>{{ consumivel.cdDepositoErp }}</td>
                <td>{{ consumivel.noDocErp }}</td>
                <td>{{ consumivel.fgRevertido }}</td>
                <td>{{ consumivel.fgStatusInteg }}</td>
                <td>{{ consumivel.dtIntegPims | date: 'dd/MM/yyyy' }}</td>
                <td>{{ consumivel.dtIntegErp | date: 'dd/MM/yyyy' }}</td>
                <td>{{ consumivel.deMensagemInteg }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <td colspan="21">Nenhum registro encontrado e/ou selecione os filtros</td>
        </ng-template>
    </p-table>
</div>